import type { ReactNode } from "react"

export const NotaSegura = ({
    children,
    className = "",
}: { children: ReactNode; className?: string }) => (
    <p className={`flex max-w-[70ch] items-start gap-2 text-xs text-soft ${className}`}>
        <svg aria-hidden="true" viewBox="0 0 16 16" className="mt-px size-3.5 shrink-0">
            <rect x="3" y="7" width="10" height="7" rx="1.5" fill="currentColor" />
            <path
                d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
        <span>{children}</span>
    </p>
)
